module.exports = __webpack_public_path__ + "static/media/car-position-icon.50030d11.svg";